module.exports = __webpack_public_path__ + "static/media/world-record.fad84c68.svg";